import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'bootstrap/dist/css/bootstrap.css'
import mavonEditor from 'mavon-editor'
Vue.use(mavonEditor)
Vue.use(ElementUI)
Vue.config.productionTip = false
window.app = new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
